import { useContext } from "react"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"

function SvgComponent(props: any) {
    const {info: {theme}} = useContext(AppInfoContext)

    return (
        <svg
            width={56}
            height={56}
            viewBox="0 0 56 56"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <rect x={4} y={4} width={48} height={48} rx={24} fill={theme["#B4E3E1"]} />
            <path
                d="M28 38c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10z"
                stroke={theme["#0D968F"]}
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M29.732 29.195c-.071-.212-.106-.318-.104-.404a.422.422 0 01.056-.22c.04-.077.146-.176.36-.374a3 3 0 10-4.086 0c.212.198.319.297.358.374.042.08.055.129.056.22.002.086-.033.192-.104.404l-.917 2.752c-.118.356-.178.533-.142.675a.5.5 0 00.216.3c.123.078.31.078.685.078h3.78c.375 0 .562 0 .685-.078a.5.5 0 00.216-.3c.036-.142-.024-.32-.142-.675l-.917-2.752z"
                stroke={theme["#0D968F"]}
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <rect
                x={4}
                y={4}
                width={48}
                height={48}
                rx={24}
                stroke={theme["#E7F6F5"]}
                strokeWidth={8}
            />
        </svg>
    )
}
  
  export default SvgComponent